// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + (chunkId === 594 ? "about" : chunkId) + "." + {"81":"e67e51d3","594":"725bf5b0"}[chunkId] + ".js";
};